<template>
  <div class="lang-radio-group " v-if="list && list.length > 1">
    <div class="radio-group" v-for="(l, index) in listFix" :key="index">
      <input :id="'lang_' + index" type="radio" :checked="l.code === modelValue" @change="changeLang(l)" :value="l" />
      <label :for="'lang_' + index">{{ l.title }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LangSelector',
  props: {
    modelValue: String // раньше было `value: String`
  },
  computed: {
    settings() {
      return this.$store.getters.settings
    },
    list() {
      return this.settings && this.settings.public && this.settings.public.lang ?
        this.settings.public.lang.map(i => {
          return {
            code: i.short.toLowerCase(),
            title: i.label
          }
        }) : undefined
    },
    listFix() {
      if (this.list && this.list.length) {
        this.list[0].code = ''
      }
      return this.list
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      langList: [
        { title: 'ua', code: '' },
        { title: 'язык', code: 'ru' },
        { title: 'en', code: 'en' }
      ]
    }
  },
  methods: {
    changeLang(title) {
      this.$emit('update:modelValue', title.code) // раньше было `this.$emit('input', title)`
    }
  }
}
</script>
